module.exports = __webpack_public_path__ + "9b6ee50f7ed60b703c4e77237d27e103.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/banner-iphone03.png
// module id = 839
// module chunks = 3